var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showToast)?_c('toast',{attrs:{"msg":_vm.msg},model:{value:(_vm.showToast),callback:function ($$v) {_vm.showToast=$$v},expression:"showToast"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }